<nz-modal [(nzVisible)]="showProviderModal"
  (nzOnCancel)="handleCancelModal()"
  nzWidth="800px"
  >
  <div class="modal-content" *nzModalContent>
    <h4>Agrega un proveedor</h4>
    <h5>Información general del proveedor</h5>
    <p>Completa la siguiente información general para poder agregar al proveedor.</p>
    <p>Una vez que lo hayas agregado, podrás completar su información en el catálogo de proveedores.</p>
      <form nz-form class="modal-form"
        [formGroup]="providerForm">
        <div class="modal-column">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="taxRegimeId">Régimen fiscal</nz-form-label>
            <nz-select nzPlaceHolder="Selecciona una opción"
              formControlName="providerTaxRegimeId" style="width: 100%;"
              id="taxRegimeId">
              <nz-option *ngFor="let regime of taxRegimes" [nzLabel]="regime.name" [nzValue]="regime.id"></nz-option>
            </nz-select>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerKey">Clave</nz-form-label>
            <nz-form-control nzErrorTip="Clave inválida">
              <input formControlName="providerKey"
                nz-input placeholder="Escribe la clave"
                id="providerKey" />
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerLegalName">Nombre o Razón social</nz-form-label>
            <nz-form-control nzErrorTip="Razón social inválida">
              <input formControlName="providerLegalName"
                nz-input placeholder="Escribe la razón social del proveedor"
                id="providerLegalName"/>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerTypeId">Tipo de proveedor</nz-form-label>
            <nz-form-control nzErrorTip="Tipo de proveedor inválido">
              <nz-select nzPlaceHolder="Selecciona una opción"
                formControlName="providerTypeId" style="width: 100%;"
                id="providerTypeId">
                @for (type of providerTypes; track type) {
                <nz-option [nzLabel]="type.providerTypeName" [nzValue]="+type.providerTypeId"></nz-option>
              }
            </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
    
        <div class="modal-column">
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerShortName">Nombre del proveedor (corto)</nz-form-label>
            <nz-form-control nzErrorTip="Nombre del proveedor (corto) inválido">
              <input formControlName="providerShortName"
                nz-input placeholder="Escribe el nombre del proveedor"
                id="providerShortName"/>
            </nz-form-control>
          </nz-form-item>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerTelephone">Celular</nz-form-label>
            <nz-form-control nzErrorTip="Teléfono inválido">
               <nz-input-number-group [nzAddOnBefore]="addOnBeforeTemplate">
                <nz-input-number formControlName="providerTelephone"
                  placeholder="Ingresa el teléfono de contacto"
                  id="providerTelephone" >
                </nz-input-number>
              </nz-input-number-group>
            </nz-form-control>
          </nz-form-item>
          <ng-template #addOnBeforeTemplate>
            <nz-select style="width: 80px;"
              formControlName="providerPhoneCode">
              <nz-option nzLabel="+52" nzValue="+52"></nz-option>
            </nz-select>
          </ng-template>
    
          <nz-form-item>
            <nz-form-label nzRequired nzFor="providerEmail">Correo electrónico</nz-form-label>
            <nz-form-control nzErrorTip="Correo electrónico inválido">
              <input formControlName="providerEmail"
                nz-input placeholder="Ingresa el correo electrónico de contacto"
                id="providerEmail"/>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control style="min-height: 64px;">
              <div style="display: flex; align-items: center; justify-content: flex-start;">
                <nz-form-label nzRequired nzFor="isInvoiceRequired">Requiere factura</nz-form-label>
                <span
                  nz-icon
                  nz-tooltip
                  [nzTooltipTitle]="'Info'"
                  nzType="question-circle"
                  theme="outline"
                ></span>
              </div>
              <label nz-checkbox formControlName="isInvoiceRequired">
                Sí
              </label>
            </nz-form-control>
          </nz-form-item>
        </div>
      </form>
  </div>
  <div *nzModalFooter class="modal-footer">
    <button nz-button class="default" (click)="handleCancelModal()">Cancelar</button>
    <button nz-button nzType="primary" (click)="onCreateProvider()" [disabled]="!providerForm.valid">Agregar proveedor</button>
  </div>
</nz-modal>